/**
 * PasteTextButton - icon-only button for the text-intake "Paste text" action.
 *
 * Sibling of AudioRecordingButton (Story 7.73 / #1149): same footer chrome, a
 * different modality. Icon-only, so it carries an accessibilityLabel ("Paste
 * text") since there is no visible text.
 */

import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';

import { TextIcon } from '../icons';

interface PasteTextButtonProps {
  /** Callback fired when button is pressed */
  onPress: () => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Size of the button (diameter in pixels) */
  size?: number;
  /** Custom styles to apply to the button container */
  style?: ViewStyle;
  /** Optional test id (E2E) */
  testID?: string;
}

export const PasteTextButton: React.FC<PasteTextButtonProps> = ({
  onPress,
  disabled = false,
  size = 48,
  style,
  testID,
}) => {
  return (
    <TouchableOpacity
      testID={testID}
      accessibilityLabel="Paste text"
      accessibilityRole="button"
      style={[
        styles.button,
        { width: size, height: size, borderRadius: size / 2 },
        disabled && styles.buttonDisabled,
        style,
      ]}
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.7}
    >
      <TextIcon size={20} color={disabled ? '#ccc' : '#666'} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#f5f5f5',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  buttonDisabled: {
    backgroundColor: '#e0e0e0',
    opacity: 0.5,
  },
});
